import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TournamentList from './tournament/TournamentList';
import BracketManagement from './tournament/BracketManagement';
import TournamentSettings from './tournament/TournamentSettings';

const TournamentManagement: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<'tournaments' | 'brackets' | 'settings'>('tournaments');
  const [selectedTournament, setSelectedTournament] = useState<{
    id: string;
    name: string;
    type: 'single_elimination' | 'double_elimination' | 'round_robin' | 'swiss';
  } | null>(null);

  return (
    <div className="space-y-6 pt-16 lg:pt-0 pb-16 sm:pb-0">
      {/* Header */}
      <div>
        <h2 className="text-4xl font-bold text-gradient-cyan mb-2">
          🏆 {t('tournament.title')}
        </h2>
      </div>

      {/* Tabs */}
      <div className="flex gap-2 border-b border-[#31383D] overflow-x-auto">
        <button
          onClick={() => setActiveTab('tournaments')}
          className={`px-6 py-3 font-semibold transition-colors ${
            activeTab === 'tournaments'
              ? 'text-cyan-400 border-b-2 border-cyan-400'
              : 'text-[#B8B8C3] hover:text-white'
          }`}
        >
          {t('tournament.tournaments')}
        </button>
        <button
          onClick={() => setActiveTab('brackets')}
          className={`px-6 py-3 font-semibold transition-colors ${
            activeTab === 'brackets'
              ? 'text-cyan-400 border-b-2 border-cyan-400'
              : 'text-[#B8B8C3] hover:text-white'
          }`}
        >
          {t('tournament.brackets')}
        </button>
        <button
          onClick={() => setActiveTab('settings')}
          className={`px-6 py-3 font-semibold transition-colors ${
            activeTab === 'settings'
              ? 'text-cyan-400 border-b-2 border-cyan-400'
              : 'text-[#B8B8C3] hover:text-white'
          }`}
        >
          {t('tournament.settings')}
        </button>
      </div>

      {/* Tab Content */}
      {activeTab === 'tournaments' && (
        <TournamentList 
          onSelectTournament={(tournament) => {
            setSelectedTournament(tournament);
            setActiveTab('brackets');
          }}
        />
      )}
      {activeTab === 'brackets' && (
        selectedTournament ? (
          <BracketManagement
            tournamentId={selectedTournament.id}
            tournamentName={selectedTournament.name}
            tournamentType={selectedTournament.type}
          />
        ) : (
          <div className="card-dark p-12 text-center">
            <div className="text-6xl mb-4">🎯</div>
            <h3 className="text-xl font-bold text-white mb-2">{t('tournament.selectTournament')}</h3>
            <p className="text-[#B8B8C3] mb-4">{t('tournament.selectTournamentDesc')}</p>
            <button
              onClick={() => setActiveTab('tournaments')}
              className="btn-primary"
            >
              {t('tournament.goToTournaments')}
            </button>
          </div>
        )
      )}
      {activeTab === 'settings' && <TournamentSettings />}
    </div>
  );
};

export default TournamentManagement;
